var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-table",
    {
      staticClass: "table",
      attrs: {
        "no-data-text": "No tienes distribuciones con copia",
        data: _vm.copies
      },
      scopedSlots: _vm._u([
        {
          key: "default",
          fn: function(ref) {
            var data = ref.data
            return _vm._l(data, function(copy, indextr) {
              return _c(
                "vs-tr",
                { key: indextr, attrs: { data: copy } },
                [
                  _c("vs-td", { attrs: { data: copy.copySubjectType.label } }, [
                    _vm._v(" " + _vm._s(copy.copySubjectType.label) + " ")
                  ]),
                  _c("vs-td", { attrs: { data: copy.copySubject.label } }, [
                    _vm._v(" " + _vm._s(copy.copySubject.label) + " ")
                  ]),
                  copy.copySubjectTypeDigitalDoc.label
                    ? _c(
                        "vs-td",
                        {
                          attrs: { data: copy.copySubjectTypeDigitalDoc.label }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(copy.copySubjectTypeDigitalDoc.label) +
                              " "
                          ),
                          _c("small", { staticClass: "d-block" }, [
                            _vm._v("institución")
                          ])
                        ]
                      )
                    : _vm._e(),
                  _c("vs-td", { attrs: { data: copy.providence } }, [
                    copy.providence
                      ? _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.providencesMap[copy.providence]) +
                              " "
                          )
                        ])
                      : _vm._e(),
                    copy.providenceExpiration
                      ? _c("span", [
                          _vm._v(
                            " - " + _vm._s(copy.providenceExpiration) + " "
                          )
                        ])
                      : _vm._e(),
                    copy.providence
                      ? _c("small", { staticClass: "d-block" }, [
                          _vm._v("providencia")
                        ])
                      : _vm._e()
                  ]),
                  _c(
                    "vs-td",
                    [
                      _c("vs-icon", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Eliminar",
                            expression: "'Eliminar'"
                          }
                        ],
                        staticClass: "cursor-pointer",
                        attrs: {
                          icon: "remove_circle_outline",
                          size: "small",
                          color: "danger"
                        },
                        on: {
                          click: function($event) {
                            return _vm.deleteCopy(copy)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            })
          }
        }
      ])
    },
    [
      _c(
        "template",
        { slot: "thead" },
        [
          _c("vs-th", [_vm._v("Distribución")]),
          _c("vs-th", [_vm._v("Lista Distribución")]),
          _c("vs-th", [_vm._v("Extra")]),
          _c("vs-th", [_vm._v("Acciones")])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }